<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { bsonId } from "@/common/utils/common";

import type { FieldType } from "@/common/types/common";

import { baseInput, baseSelect } from "@/common/components";

const { t } = useI18n();

const emit = defineEmits(["update-data", "update-method"]);

const props = defineProps<{
  data: FieldType | null;
}>();

const DEFAULT_PAYLOAD = {
  id: bsonId(),
  name: "",
  type: "",
  answer: "",
};

const payload = ref({ ...DEFAULT_PAYLOAD });

const typeOptions = computed(() => [
  {
    option: t("question.types.input"),
    value: "text",
  },
  {
    option: t("common.labels.number"),
    value: "number",
  },
]);

function update() {
  emit("update-data", payload.value);
}

onMounted(() => {
  if (props.data) {
    payload.value = {
      ...DEFAULT_PAYLOAD,
      ...props.data,
    };

    update();
  }
});
</script>

<template>
  <section class="report-field">
    <base-select
      v-model="payload.type"
      :value="payload.type"
      :options="typeOptions"
      :is-empty="false"
      @change="update()"
    >
      <template #label>
        {{ t("common.labels.type") }}
      </template>
    </base-select>

    <base-input
      v-model="payload.name"
      :value="payload?.name"
      :placeholder="t('question.placeholders.name')"
      @blur="update()"
    >
      <template #label>
        {{ t("common.labels.name") }}
      </template>
    </base-input>
  </section>
</template>

<style lang="scss" scoped>
.report-field {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .method {
    display: flex;
    flex-direction: column;
    background: var(--background);
    padding-block: 0.75rem;
    padding-inline: 1rem;
    border-radius: 0.5rem;

    .fields {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
  }
}
</style>
